import { InjectionToken } from '@angular/core';

export const ACCOUNT_BASE_URL = new InjectionToken<string>('ACCOUNT_BASE_URL');
